<template>
  <div class="RLayoutBox">
    <h2>报废机动车回收拆解业务全场景解决方案</h2>
    <img src="../assets/img/lct.png" alt="" width="80%" />
  </div>
</template>
 
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.RLayoutBox {
  text-align: center;
  h2 {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>